export function zPad(num: number, size: number): string {
  let numStr = num.toString();
  while (numStr.length < size) numStr = "0" + numStr;
  return numStr;
}

export const formatNumberToTwoDecimals = (value: unknown): string => {
  if (value === null || value === undefined) return "0";
  const num = Number(value);
  if (isNaN(num)) return String(value);
  return num.toFixed(2).replace(".00", "");
};
